// extracted by mini-css-extract-plugin
export var formBox = "subscribeBlock-module--form-box--56208";
export var formBoxSubtitle = "subscribeBlock-module--formBoxSubtitle--0921f";
export var formBoxTitle = "subscribeBlock-module--form-box-title--086ca";
export var invalid = "subscribeBlock-module--invalid--2ed8d";
export var thankYou = "subscribeBlock-module--thank-you--4f868";